const MAIN_FRAMES = {
  ALERT_VIEW: 'Alert View',
  ALERT_DETAIL: 'Alert Detail',
  EVENT_ALERT_LIST_VIEW: 'Event Alert List View',
  NOTIFICATION_HISTORY_VIEW: 'Notification History View',
} as const;

export const ALERT_FRAME_NAMES = {
  ALERT_VIEW: {
    FILTERS: `${MAIN_FRAMES.ALERT_VIEW}/Filters`,
    LIST: `${MAIN_FRAMES.ALERT_VIEW}/Alert List`,
    TAGS: `${MAIN_FRAMES.ALERT_VIEW}/Tags`,
  },
  ALERT_DETAIL: {
    INFORMATION: `${MAIN_FRAMES.ALERT_DETAIL}/Information`,
    NOTIFICATION: `${MAIN_FRAMES.ALERT_DETAIL}/Notification`,
    CURRENT: `${MAIN_FRAMES.ALERT_DETAIL}/Current`,
    CURRENT_CLEAR: `${MAIN_FRAMES.ALERT_DETAIL}/[Clear] Current`,
    HISTORY_TREND: `${MAIN_FRAMES.ALERT_DETAIL}/History`,
    HISTORY_SORT_BY_TIME: `${MAIN_FRAMES.ALERT_DETAIL}/History - Sort by Time`,
    PATH: `${MAIN_FRAMES.ALERT_DETAIL}/Information - Path`,
  },
  EVENT_ALERT_LIST_VIEW: {
    FILTERS: `${MAIN_FRAMES.EVENT_ALERT_LIST_VIEW}/Filters`,
    EVENT_ALERT_TOP: `${MAIN_FRAMES.EVENT_ALERT_LIST_VIEW}/Event Alert Top`,
    EVENT_ALERT_HISTORY: `${MAIN_FRAMES.EVENT_ALERT_LIST_VIEW}/Event Alert History`,
    EVENT_ALERT_LIST: `${MAIN_FRAMES.EVENT_ALERT_LIST_VIEW}/Event Alert List`,
    EVENT_ALERT_KEYWORD: `${MAIN_FRAMES.EVENT_ALERT_LIST_VIEW}/Event Alert Keyword`,
    EVENT_ALERT_KEYWORD_UPDATE: `${MAIN_FRAMES.EVENT_ALERT_LIST_VIEW}/[Update] Event Alert Keyword`,
  },
  NOTIFICATION_HISTORY_VIEW: {
    FILTERS: `${MAIN_FRAMES.NOTIFICATION_HISTORY_VIEW}/Filters`,
    LIST: `${MAIN_FRAMES.NOTIFICATION_HISTORY_VIEW}/Notification History View`,
    DETAIL: `${MAIN_FRAMES.NOTIFICATION_HISTORY_VIEW}/Notification Status Detail`,
  },
} as const;
